import React from 'react';
import {useParams} from 'react-router-dom';
import resolvePath from '../../../misc/resolvePath';
import ButtonLink from '../../elements/ButtonLink';
import Checkbox from '../../elements/forms/Checkbox';
import ScreenTitle from '../../elements/ScreenTitle/ScreenTitle';
import ToolbarLayout from '../../elements/ToolbarLayout';
import ToolbarButton from '../../elements/ToolbarButtons/ToolbarButton';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import Screen from '../Screen';
import CategoriesTabs from './common/CategoriesTabs';
import connectQuests from './common/connectQuests';

class EventQuestsCategoriesSelection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pending: {},
        };
        this.queue = Promise.resolve();
    }
    render() {
        let {i18n, event, categories} = this.props,
            header = (
                <div className="header">
                    <TopBarEvent event={event} qa={true} returnURL={'..'} />
                    <ScreenTitle screen={i18n['label.questions']} event={event} />
                    <ToolbarLayout>
                        <CategoriesTabs
                            {...this.props}
                            hideMineTab={true}
                            catLink={this.props.catLink || (catId => resolvePath(location.pathname, '..', '..', catId?.toString() || ''))}
                            category={false}
                        />
                        <ToolbarButton
                            src="img/ellipsis-horizontal.png"
                            key="more"
                            backgroundColor={event.settings.secondary_color}
                            href="./.."
                            iconColor="white"
                        />
                    </ToolbarLayout>
                    <div className="blocklink">
                        <h4
                            style={{
                                color: event.settings.secondary_color,
                            }}>
                            {i18n['title.group-subscription']}
                        </h4>
                        <div className="subtitle">{event.settings.question_category_intro || i18n['explain.group-subscription']}</div>
                    </div>
                </div>
            );

        return (
            <Screen header={header}>
                {_(this.props.subscribableCategories)
                    // .sortBy([cat => (cat.subscribed ? 0 : 1), 'title'])
                    .sortBy('title')
                    .map(cat => (
                        <Checkbox
                            className="block"
                            key={cat.id}
                            checked={cat.subscribed}
                            spinner={this.state.pending[cat.id]}
                            onChange={this.handleSubscriptionChange.bind(this, cat)}
                            style={{
                                paddingRight: 100,
                            }}>
                            <h4
                                style={{
                                    color: event.settings.secondary_color,
                                }}>
                                {cat.title}
                            </h4>
                            <p>{cat.description}</p>
                            <ButtonLink
                                className="smallButton vertical-center"
                                href={['/events', event.id, 'qa', cat.id].join('/')}
                                style={Object.assign(
                                    {
                                        position: 'absolute',
                                        right: 10,
                                        width: 80,
                                    },
                                    event._local.styles.button_secondary
                                )}>
                                {i18n['button.info']}
                            </ButtonLink>
                        </Checkbox>
                    ))
                    .value()}
            </Screen>
        );
    }
    handleSubscriptionChange(cat, checked) {
        this.setState({
            pending: {
                ...this.state.pending,
                [cat.id]: true,
            },
        });
        // app.store.dispatch(app.actions.events.updateQuestionCategory(this.props.eventId, cat.id, {subscribed: checked}));

        let call;
        if (checked) {
            call = () =>
                app.api.questions.joinGroup(this.props.eventId, cat.id).catch(e => {
                    console.error(e);
                });
        } else {
            call = () =>
                app.api.questions.leaveGroup(this.props.eventId, cat.id).catch(e => {
                    console.error(e);
                });
        }

        this.queue.then(call).then(() => {
            this.setState({
                pending: {
                    ...this.state.pending,
                    [cat.id]: false,
                },
            });
        });
    }
}

const ConnectedEventQuestsCategoriesSelection = connectQuests(EventQuestsCategoriesSelection);

export default props => {
    const params = useParams();
    return <ConnectedEventQuestsCategoriesSelection {...params} />;
};

// for inside create question route
export const EventQuestsCategoriesSelectionWhileCreatingQuestion = props => {
    const params = useParams();
    return (
        <ConnectedEventQuestsCategoriesSelection
            {...params}
            catLink={catId => resolvePath(location.pathname, '..', '..', '..', catId?.toString() || 'all', 'create')}
        />
    );
};
